import { Controller } from "@hotwired/stimulus"

// "Proceed anyway" on the locked-org warning modal. When a source form id is
// given (a full-page form still in the DOM behind the modal, e.g. the new-invoice
// form), inject an `override` field into it and re-submit it so the user's input
// is preserved. Otherwise (activation/sweep, which carry no input) submit the
// modal's own one-field override form.
export default class extends Controller {
  static targets = ["fallbackForm"]
  static values = { source: String }

  proceed() {
    const sourceForm = this.sourceValue ? document.getElementById(this.sourceValue) : null

    if (sourceForm) {
      if (!sourceForm.querySelector('input[name="override"]')) {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = "override"
        input.value = "1"
        sourceForm.appendChild(input)
      }
      sourceForm.requestSubmit()
    } else {
      this.fallbackFormTarget.requestSubmit()
    }
  }
}
